import { FormGroup, Input } from 'reactstrap';

export default function PageSizer({ onChangeHandler, selectedPageSize = 10 }) {
  return (
    <FormGroup>
      <Input
        type="select"
        name="select"
        id="exampleSelect"
        onChange={(e) => {
          onChangeHandler(e.target.value);
        }}
        style={{
          height: 30,
          color: '#000',
          padding: 0,
          marginLeft: 5,
          borderRadius: 2,
        }}
      >
        <option value={10} selected={selectedPageSize === 10}>
          10 / page
        </option>
        <option value={25} selected={selectedPageSize === 25}>
          25 / page
        </option>
        <option value={50} selected={selectedPageSize === 50}>
          50 / page
        </option>
        <option value={100} selected={selectedPageSize === 100}>
          100 / page
        </option>
      </Input>
    </FormGroup>
  );
}
